import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMail, FiLock, FiLogIn, FiAlertCircle, FiBox } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');
    setIsLoading(true);

    try {
      const result = await login(username, password);
      if (result.success) {
        navigate('/');
      } else {
        setLocalError(result.error || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      setLocalError('An unexpected error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass-card p-5 w-100"
        style={{ maxWidth: '450px' }}
      >
        <div className="text-center mb-5">
          <h2 className="fw-bold neon-text mb-2">BGB Franchise</h2>
          <p className="text-muted">Enter your credentials to access the panel</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="form-label text-muted small uppercase fw-bold mb-2">User Id </label>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 border-opacity-10 text-muted">
                <FiBox />
              </span>
              <input
                type="text"
                className="form-control border-start-0 ps-0"
                placeholder="name@company.com"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-4">
            <div className="d-flex justify-content-between mb-2">
              <label className="form-label text-muted small uppercase fw-bold mb-0">Password</label>
              <Link to="/forgot-password" style={{ color: 'var(--primary-color)' }} className="text-decoration-none small">Forgot password?</Link>
            </div>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 border-opacity-10 text-muted">
                <FiLock />
              </span>
              <input
                type="password"
                className="form-control border-start-0 ps-0"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-4 form-check">
            <input type="checkbox" className="form-check-input" id="remember" />
            <label className="form-check-label text-muted small" htmlFor="remember">Keep me logged in</label>
          </div>

          {localError && (
            <div className="alert alert-danger d-flex align-items-center py-2" role="alert">
              <FiAlertCircle className="me-2" />
              <span className="small">{localError}</span>
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary w-100 py-3 fw-bold d-flex align-items-center justify-content-center gap-2"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span>Signing in...</span>
              </>
            ) : (
              <>
                <FiLogIn /> Sign In
              </>
            )}
          </button>
        </form>

        <div className="mt-5 text-center">
          <p className="text-muted small">
            Don't have an account? <Link to="/register" style={{ color: 'var(--secondary-color)' }} className="text-decoration-none fw-bold">Register Branch</Link>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Login;
